import React from 'react';
import { map, last, constant, mapObject } from 'underscore';
import PropTypes from 'prop-types';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getNavigateContentStyles } from '../styles';

function NavigateContent(props) {
  const { crumbs, classes } = props;
  const crumbSpans = map(crumbs, (crumb, index) => <span key={index}>{`${crumb} > `}</span>);

  if (crumbSpans.length > 0) {
    crumbSpans[crumbSpans.length - 1] = (<span key={crumbSpans.length - 1} className={classes.navigateContentLastItem}>{last(crumbs)}</span>);
  }

  return (
    <div className={classes.navigateContent}>
      {crumbSpans}
    </div>);
}

NavigateContent.propTypes = {
  crumbs: PropTypes.arrayOf(PropTypes.string),
  classes: PropTypes.shape(mapObject(
    getNavigateContentStyles({}, {}),
    constant(PropTypes.string.isRequired)
  )).isRequired,
};

NavigateContent.defaultProps = {
  crumbs: [],
};

export const StyledNavigateContent = withDefaultStyles(NavigateContent, getNavigateContentStyles);
